<template>
  <div class="w-100 overlay">
    <BCarousel
      id="project-carousel"
      v-model="slide"
      controls
      indicators
      :interval="0"
    >
      <BCarouselSlide
        v-for="(img, i) in projectImages"
        :id="'carousel-img-' + img.imageNumber"
        :key="i"
        style="height:100%"
      >
        <div class="slide-wrapper">
          <!-- メイン画像 -->
          <img :src="img.imagePath" class="carousel-img" :data-image-number="img.imageNumber" :data-bookmark="img.bookmark" :data-file-name="img.fileName"/>
          <img src="~@/assets/img/heart-active.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && img.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
          <img src="~@/assets/img/heart-passive.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && !img.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
        </div>
      </BCarouselSlide>
    </BCarousel>
    <div class="mt-3 thumb-container">
      <div
        class="thumb-track gap-3"
        :style="{ transform: projectImages.length > 1 ? `translateX(-${thumbIndex * 202}px)` : none }"
      >
        <div
          v-if="projectImages.length > 1"
          v-for="(image, index) in loopedImages"
          :key="'thumb-' + index"
          :id = "'thumb-img-' + index"
          class="thumb-wrapper"
          @click="onThumbClick(index)"
        >
          <div class="thumb-wrapper">
            <img
              :src="image.imagePath"
              class="thumb-img"
              :class="{ active: isActive(index) }"
            />
            <img src="~@/assets/img/heart-active.png" class="thumb-like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && image.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
            <img src="~@/assets/img/heart-passive.png" class="thumb-like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && !image.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
          </div>
        </div>
        
        <div
          v-if="projectImages.length === 1"
          v-for="(image, index) in projectImages"
          :key="'thumb-' + index"
          :id = "'thumb-img-' + index"
          class="thumb-wrapper text-center"
          @click="onThumbClick(index)"
        >
          <div class="thumb-wrapper">
            <img
              :src="image.imagePath"
              class="thumb-img"
              :class="{ active: true }"
            />
            <img src="~@/assets/img/heart-active.png" class="thumb-like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && image.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
            <img src="~@/assets/img/heart-passive.png" class="thumb-like-icon" style="right: 10px; bottom: 10px;" v-if="showBookmarkIcon && !image.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue-next'

export default {
  name: 'ProductSelectionSlider',
  components: { BCarousel, BCarouselSlide },
  props: {
    projectImages: { type: Array, default: () => [] },
    routeProjectType: String,
    showBookmarkIcon: { type: Boolean, default: true }
  },
  emits: ['slideChanged', 'checkImageNumber', 'checkBookmark'],
  data () {
    return {
      slide: 0,
      thumbIndex: 0,
      offset: 0,
      loopedImages: []
    }
  },
  watch: {
    projectImages: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.emitCurrent()
          this.emitCheckImageNumber()
          this.emitCheckBookmark()
        })
      }
    },
    slide (newVal) {
      this.emitCurrent()
      this.emitCheckImageNumber()
      this.emitCheckBookmark()

      let plusNumber = 0
      if (this.projectImages.length > 4) {
        plusNumber = 4
      }
      this.thumbIndex = newVal + plusNumber
      
      const id = 'thumb-img-' + this.thumbIndex
      this.$emit('sendSignaling', id)
    },
    thumbIndex (val) {
      const total = this.projectImages.length
  
      // 右端超え
      if (val >= total + this.offset) {
        setTimeout(() => {
          this.thumbIndex = val - total
          // this.thumbIndex = this.offset
        }, 0)
      }
  
      // 左端超え
      if (val < this.offset) {
        setTimeout(() => {
          this.thumbIndex = total + this.offset - 1
        }, 0)
      }
    }
  },
  computed: {
    loopedImages () {
      if (!this.projectImages.length) return []
      if (this.projectImages.length > 4) {
        this.offset = 4
      }
  
      return [
        ...this.projectImages.slice(-this.offset),
        ...this.projectImages,
        ...this.projectImages.slice(0, this.offset)
      ]
    }
  },
  mounted () {
    if (!this.projectImages.length) return []
    if (this.projectImages.length > 4) {
      this.thumbIndex = 4
      this.offset = 4
    }
    this.loopedImages = [
      ...this.projectImages.slice(-this.offset),
      ...this.projectImages,
      ...this.projectImages.slice(0, this.offset)
    ]
  },
  methods: {
    emitCheckImageNumber () {
      const image = this.projectImages[this.slide] ?? null
      this.$emit('checkImageNumber', image?.imageNumber ?? null)
    },
    emitCheckBookmark () {
      const image = this.projectImages[this.slide] ?? null
      this.$emit('checkBookmark', image?.imageNumber ?? null)
    },
    emitCurrent () {
      const image = this.projectImages[this.slide] ?? null
      this.$emit('slideChanged', { index: this.slide, image })
    },
    goToSlide (index) {
      this.slide = index
    },
    onThumbClick (index) {
      this.thumbIndex = index
  
      // 実際のslideに変換
      let minusNumber = 0
      if (this.projectImages.length > 4) {
        minusNumber = 4
      }
      const realIndex = (index - minusNumber + this.projectImages.length) % this.projectImages.length
      this.slide = realIndex
    },
    isActive (index) {
      return index === this.thumbIndex
    }
  }
}
</script>
<style scoped>
:root {
  --indicator-bar-h: 44px;
  --pad-bg: #f2f2f2;
}

#project-carousel {
  display: flex;
  flex-direction: column;
  height: calc(60vh + var(--indicator-bar-h));
  max-height: calc(600px + var(--indicator-bar-h));
}

#project-carousel :deep(.carousel-inner) {
  max-height: 600px;
  aspect-ratio: 3/2;
}

#project-carousel :deep(.carousel-item) {
  height: 100%;
  background: var(--pad-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

#project-carousel :deep(img.b-img) {
  display: none !important;
}

#project-carousel :deep(.carousel-indicators) {
  order: 2;
  position: static; /* ←重要：下に“流し込む” */
  height: var(--indicator-bar-h);
  margin: 0;
  background: var(--pad-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

#project-carousel :deep(.carousel-indicators button),
#project-carousel :deep(.carousel-indicators [data-bs-target]) {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 6px;

  text-indent: 0;
  background-color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}

#project-carousel :deep(.carousel-indicators .active) {
  background-color: rgba(0, 0, 0, 0.65);
}

#project-carousel :deep(.carousel-caption) {
  position: static;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  height: 100%;
}

.thumb-img {
  width: 186px;
  height: 124px;
  cursor: pointer;
  opacity: 0.6;
  transition: 0.3s;
  object-fit: contain;
  background: #ababab;
}

.thumb-img.active {
  border: 2px solid #0d6efd;
  opacity: 1;
}

.thumb-wrapper {
  position: relative;
}

.thumb-like-icon {
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 20px;
  height: 20px;
}

.slide-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  aspect-ratio: 3/2;
}

.like-icon {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 40px;
  height: 40px;
  z-index: 10;
  object-fit: unset !important;
}

.thumb-container {
  overflow: hidden;
  width: 100%;
}

.thumb-track {
  display: flex;
  transition: transform 0.4s ease;
}
</style>
